<template>
    <b-container fluid class="mt--7">
        <view-item v-if="!!item" :item="item" @success="alertSuccess($event)" @delete-item="deleteType"
            @cancel="item = false" @error="showError"></view-item>

        <list-items v-else title="Customer Request Categories" :items="categories" @show-item="showItem" ref="table">
            <b-row>
                <b-col offset="8" class="text-right">
                    <b-button variant="primary" v-if="hasPermissionCreate" @click="item = {}">Add Category</b-button>
                </b-col>
            </b-row>
        </list-items>
    </b-container>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'requestCategories',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [
        popupMixins,
        utilityMixins,
        permissionsMixins,
        errorHandlingMixins,
    ],
    data: () => {
        return {
            item: null,
            componentName: 'Request Category',
        }
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        categories() {
            const categories =
                this.$store.state.requestCategory.categories || []
            console.log('categories', categories)
            return categories
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        doSearch() {
            this.$store.dispatch('requestCategory/fetchAll')
        },

        showItem(id) {
            const item = this.categories.find(x => x.id === id)
            this.item = { ...item }
        },

        alertSuccess(action) {
            console.log(this.item)
            this.genericToast(
                this.componentName,
                action,
                'success',
                `${this.componentName
                } has been succcessfully ${action.charAt(0).toUpperCase() +
                action.slice(1)
                }d`
            )
            //this.doToast('Success', `Item ${action}!`, 'success')
            this.item = null
            this.doSearch()
        },

        showError(error, name) {
            const interror = 'Internal Server Error'
            if (interror == error.message) {
                this.genericToast(
                    this.componentName,
                    'Duplicate',
                    'danger',
                    `"${name}" already exists as an ${this.componentName
                    }. Please create a new ${this.componentName.toLowerCase()}`
                )
            }
        },
    },
}
</script>
<style></style>
